import { read, utils } from 'xlsx';//for sheet.JS
import { useRef, useState, useEffect } from 'react';// for hooks and mount loading
import React from 'react';// for react
import * as XLSX from 'xlsx'

import axios from 'axios';
import 'semantic-ui-css/semantic.min.css'
import {BrowserRouter as Router,Routes, Route, Link } from 'react-router-dom';

 










const handleSubmit = async (e) => {
    e.preventDefault()//dont reload the page
    
}


function Diary(){
    const [Name,setName] = useState('') // using hooks so they can be used in the form 
    const [openBalance,setopenBalance] = useState()
    const [priorData, setpriorData] = useState([])
    const [priorCash, setpriorCash] = useState(0);
    const [cash,setCash] = useState(0) 
    const [Entries,setEntries] = useState()//Entry Hook
    const [submit, setSubmit] = useState(false)
    
    const [diff, setDiff] = useState();
    const [A2, setA2] = useState(0);
    const [ramsy, setRamsy] = useState(0);
    const [sugar, setSugar] = useState(0);
    const [lyca, setLyca] = useState(0);
    const [phone, setPhone] = useState(0);
    const [photocopy, setPhotocopy] = useState(0);
    const [lcd, setLcd] = useState(0);
    const [southall, setSouthall] = useState(0);
    const [opt1name,setopt1name] = useState('')
    const [opt1, setopt1] = useState(0)
    const [opt2name,setopt2name] = useState('')
    const [opt2, setopt2] = useState(0)
    const [opt3name,setopt3name] = useState('')
    const [opt3, setopt3] = useState(0)
    const [opt4name,setopt4name] = useState('')
    const [opt4, setopt4] = useState(0)
    const [post,setPosted] = useState('');
    const [opt5name,setopt5name] = useState('')
    const [opt5, setopt5] = useState(0)
    const [paypointTill, setPaypointTill] = useState(0);
    const [paypointReport, setPaypointReport] = useState(0);
    const[paypointDiff,setpaypointDiff] = useState()
    const [closing,setClosing] = useState(0)
    const [currentDate,setcurrentDate] = useState('')
    const [currentDay, setcurrentDay] = useState('')



    

    
    
    function convertJSON({Name, currentDate, currentDay,A2,ramsy, sugar, lyca, phone, photocopy, lcd , southall ,opt1name, opt1, opt2name, opt2, opt3name, opt3, opt4name, opt4, opt5name, opt5 }){//using props

      


      fetch("https://sheet.best/api/sheets/6a525b7c-b08e-453a-9e17-9f8543360d9b")//fetching prior accounts
      .then((response) => response.json())
      .then((data) => {
          console.log(data);
          setpriorData(data)
        })
        .catch((error) => {
          console.error(error);
          alert("404 Error")
        });
        let obj = priorData[priorData.length-1]
        console.log(obj)
        let newopening = obj.closing_balance
        console.log(newopening)

   

        const date = new Date()//getting date and time
        let total =(parseFloat(A2) + parseFloat(ramsy) + parseFloat(sugar) + parseFloat(lyca) + parseFloat(phone) + parseFloat(photocopy) + parseFloat(lcd) + parseFloat(southall)) + (parseFloat(opt1) + parseFloat(opt2) + parseFloat(opt3) + parseFloat(opt4) + parseFloat(opt5))
        // finding total of all expendituring costs
        console.log(parseFloat(lyca))
        let closing_balance = (parseFloat(newopening) + parseFloat(cash) ) - total // calculating closing balance 
        if (isNaN(closing_balance) === true){
          alert("Error, Please Try Again, Make sure all other values 0 and submit again")
        }
        setClosing(closing_balance)
        const JSONobj = {
          Date: date,
          Name: Name,
          open_balance: newopening,
          cash: cash,
          A2: A2,
          ramsy: ramsy,
          sugar: sugar,
          lyca: parseFloat(lyca),
          phone: phone,
          photocopy: photocopy,
          lcd: lcd,
          southall: southall,
          opt1name:opt1name,
          opt1: opt1,
          opt2name:opt2name,
          opt2: opt2,
          opt3name:opt3name,
          opt3: opt3,
          opt4name:opt4name,
          opt4: opt4,
          opt5name: opt5name,
          opt5: opt5,
          currentDay:currentDay,
          currentDate:currentDate,
          closing_balance: closing_balance.toFixed(2)
          
        }
        console.log(JSONobj)// checking the correct object is being parse

        setSubmit(!submit)//setting submit field to True
        setEntries(JSONobj)//Setting JSON to a hook so it can be used globally
        // +', "Money":'+Money
        





        

        
        
        
    }


    function Submit(){
        axios.post('https://sheet.best/api/sheets/6a525b7c-b08e-453a-9e17-9f8543360d9b', Entries)
        .then(response => {
          console.log(response);
          setPosted('Success!')
        })

    }

    

    return(
        <form onSubmit={handleSubmit} >
          <div className="entireForm">
              <div className="labelWrapper">
                <label htmlFor="name">Name:</label>
                <input 
                 type="text" 
                 id="name"
                 className="typein__box"
                 onChange = {(e)=> setName(e.target.value)} 
                //  using a imaginary variable to setName when changed
                 value = {Name}
                 required
                />

                <label htmlFor="currentDate">Current Date:</label>
                <input
                 className="typein__box"
                 type="currentDate" 
                 id="currentDate"

                 onChange = {(e)=> setcurrentDate(e.target.value)} 
                 value = {currentDate}
                 required
                />

             
                <label htmlFor="currentDay">Current Day:</label>
                <input
                 className="typein__box"
                 type="currentDay" 
                 id="currentDay"

                 onChange = {(e)=> setcurrentDay(e.target.value)} 
                 value = {currentDay}
                 required
                />
               
              <div className="everyForm">
               <div className="firstTotal">
                

               <label htmlFor="Cash"> Cash:</label>
                <input 
                 className="typein__box"
                 type="text" 
                 id="cash"
                 onChange = {(e)=> setCash(e.target.value)} 
                 value = {cash}
                /> 
                {/* boss */}

                <label htmlFor="A2"> A2:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="A2"
                  onChange={(e) => setA2(e.target.value)}
                  value={A2}
                />

                <label htmlFor="ramsy"> ramsy:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="ramsy"
                  onChange={(e) => setRamsy(e.target.value)}
                  value={ramsy}
                />

                <label htmlFor="sugar"> sugar:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="sugar"
                  onChange={(e) => setSugar(e.target.value)}
                  value={sugar}
                />

                <label htmlFor="lyca"> lyca:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="lyca"
                  onChange={(e) => setLyca(e.target.value)}
                  value={lyca}
                />

                <label htmlFor="phone"> phone:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="phone"
                  onChange={(e) => setPhone(e.target.value)}
                  value={phone}
                />

                <label htmlFor="photocopy"> photocopy:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="photocopy"
                  onChange={(e) => setPhotocopy(e.target.value)}
                  value={photocopy}
                />

                <label htmlFor="lcd"> lcd:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="lcd"
                  onChange={(e) => setLcd(e.target.value)}
                  value={lcd}
                />

                <label htmlFor="southall"> southall:</label>
                <input
                  className="typein__box"
                  type="text"
                  id="southall"
                  onChange={(e) => setSouthall(e.target.value)}
                  value={southall}
                />

               

                    {/* opt1name */}
                    <label htmlFor="opt1name"> Option 1 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt1name"
                      onChange={(e) => setopt1name(e.target.value)}
                      value={opt1name}
                    />

                    {/* opt1 */}
                    <label htmlFor="opt1"> Option 1:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt1"
                      onChange={(e) => setopt1(e.target.value)}
                      value={opt1}
                    />

                    {/* opt2name */}
                    <label htmlFor="opt2name"> Option 2 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt2name"
                      onChange={(e) => setopt2name(e.target.value)}
                      value={opt2name}
                    />

                    {/* opt2 */}
                    <label htmlFor="opt2"> Option 2:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt2"
                      onChange={(e) => setopt2(e.target.value)}
                      value={opt2}
                    />

                    {/* opt3name */}
                    <label htmlFor="opt3name"> Option 3 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt3name"
                      onChange={(e) => setopt3name(e.target.value)}
                      value={opt3name}
                    />

                    {/* opt3 */}
                    <label htmlFor="opt3"> Option 3:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt3"
                      onChange={(e) => setopt3(e.target.value)}
                      value={opt3}
                    />

                    {/* opt4name */}
                    <label htmlFor="opt4name"> Option 4 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt4name"
                      onChange={(e) => setopt4name(e.target.value)}
                      value={opt4name}
                    />

                    {/* opt4 */}
                    <label htmlFor="opt4"> Option 4 :</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt4"
                      onChange={(e) => setopt4(e.target.value)}
                      value={opt4}
                    />

                    {/* opt5name */}
                    <label htmlFor="opt5name"> Option 5 Name:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt5name"
                      onChange={(e) => setopt5name(e.target.value)}
                      value={opt5name}
                    />

                    {/* opt5 */}
                    <label htmlFor="opt5"> Option 5:</label>
                    <input
                      className="typein__box"
                      type="text"
                      id="opt5"
                      onChange={(e) => setopt5(e.target.value)}
                      value={opt5}
                    />

               
                

                
               

                
     
                </div>



                
                
                
                
                
                <button className="button-10" onClick={() => convertJSON({Name, currentDate, currentDay,cash, A2,ramsy, sugar, lyca, phone, photocopy, lcd , southall ,opt1name, opt1, opt2name, opt2, opt3name, opt3, opt4name, opt4, opt5name, opt5 })} >Submit</button>
                { submit ? <div className = "finalMessage"><p> Closing Balance:£ { closing.toFixed(2) }</p>  <p className='green'>{post}</p> <Link to="/"> <button className ="confirmButton button-10" onClick={() => Submit(Entries)}>Confirm Submit </button></Link><a href="mailto:hsugarnan2005@gmail.com">Report Error in Accounts</a></div>: <p className="smallFont">SugarTech 2023©</p>  }
              </div>
             </div>
          </div>
            </form>
    )


}


export default Diary

 